<template>
  <v-btn
    color="primary"
    depressed
    x-small
    :disabled="disabled"
    :loading="loading"
    :title="disabled ? 'This user is not allowed to log in' : 'Login as User'"
    @click.stop="onImpersonate"
  >
    Login as User
  </v-btn>
</template>

<script>
import { mapActions, mapMutations } from "vuex";

export default {
  props: {
    targetUserId: {
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    ...mapActions(["issueImpersonationCode"]),
    ...mapMutations(["toggleSnackbar"]),
    async onImpersonate() {
      const newTab = window.open("", "_blank");

      if (!newTab) {
        this.showError(
          "The impersonation tab was blocked. Allow popups and try again.",
        );
        return;
      }

      newTab.opener = null;
      this.loading = true;

      try {
        const exchangeCode = await this.issueImpersonationCode(
          this.targetUserId,
        );
        const route = this.$router.resolve({
          path: "/impersonate",
          query: { code: exchangeCode },
        });

        if (!newTab.closed) {
          newTab.location.href = new URL(
            route.href,
            window.location.origin,
          ).toString();
        }
      } catch (e) {
        if (!newTab.closed) newTab.close();

        const errorCode = e.response?.data?.Error?.errorCode;

        if (errorCode === 10403) {
          this.showError("This user was not found or is not allowed to log in.");
        } else if (errorCode === 10402) {
          this.showError("Another superadmin cannot be impersonated.");
        } else {
          this.showError(
            "Unable to start impersonation. Please try again later.",
          );
        }
      }

      this.loading = false;
    },
    showError(text) {
      this.toggleSnackbar({
        open: true,
        color: "error",
        text,
        timeout: 6000,
      });
    },
  },
};
</script>
